import {Component, Inject, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {MagentoCustomerService} from '../../../../../../services/magentocustomer.service';
import {RegistryService} from '../../../../services/registry.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CustomerAddress} from '../../../../models/CustomerInfo/CustomerAddress';
import {environment} from '../../../../../../environments/environment';

@Component({
  selector: 'app-user-addresses',
  templateUrl: './user-addresses.component.html',
  styleUrls: ['./user-addresses.component.css']
})
export class UserAddressesComponent implements OnInit {

  id: string;

  public href = '';

  title = 'User Address';
  searchText: any;

  form = new FormGroup({
    first_name: new FormControl('', Validators.required),
    last_name: new FormControl('', Validators.required),
    city: new FormControl(''),
    street: new FormControl(''),
    phone: new FormControl(''),
  });

  constructor(private router: Router,
              private registry: RegistryService,
              private dialogRef: MatDialogRef<UserAddressesComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
  }

  close() {

    this.dialogRef.close();
  }



  // for create a new user
  createAddress() {

    const new_address = new CustomerAddress();
    new_address.firstname = this.form.value.first_name;
    new_address.lastname = this.form.value.last_name;
    new_address.city = this.form.value.city;
    new_address.street = [this.form.value.street];
    new_address.telephone = this.form.value.phone;
    new_address.country_id = environment.defaultCountry;
    new_address.id = null;


    this.registry.EmitCustomerAddressAdded(new_address);
    this.dialogRef.close();

    }




}
